import React, { useContext, useState } from "react";

import { Title } from "../../../../../stories/Title/Title";
import { Operation, PriorityEnum } from "../../../../../utils/Enum.types";
import { Form, Formik, FormikProps } from "formik";
import { ItemList } from "../../../../../utils/formTypes";
import { materialItemValidation } from "../../../../../utils/validationSchema";
import { LabelProps } from "../../../../../utils/types";
import { Label } from "../../../../../stories/Label/Label";
import TextArea from "../../../../../stories/TextArea/TextArea";
import {
  CustomModal,
  handleFormEvent,
  handleMUISelectEvent,
  hanldeTextAreaFormEvent,
} from "../../../../../utils/UtilFunctions";
import InputNumber from "../../../../common/Input/InputNumber";
import InputHoc from "../../../../common/Input/Index";
import { Button } from "../../../../../stories/Button/Button";
import { INPUT, emptyMessage } from "../../../../../utils/constants";
import { AppContext, itmType } from "./statesProvider/materialContext";
import {
  AtsStckItemEdge,
  ItemQueryType,
} from "../../masters/items/queries/types";
import { materialStatesPayloadTypes } from "./statesProvider/materialReducer";
import DataFetch from "../../../../../images/OpenIcon.svg";
import MultiSelectSupplier from "./MultiSelectSupplier";
import { AddModalStyles } from "../../../../../styles/CustomModalStyles";
import Assign from "./Assign";
import {
  FormAutocomplete,
  formClasses,
} from "../../../../../styles/AutocompleteStyles";
import { Keys } from "../../../../../utils/Enum.keys";
import { TextField } from "@mui/material";
import Close from "../../../../../images/Close.svg";
import ItemSelect from "../../../../../customComponents/ItemSelect";
import { MrfQueryType } from "./queries/types";
import useLabels from "../../../../../customHooks/useLabels";
import useFormJson from "../../../../../json/useFormJson";
import { LdgrQueryType } from "../../masters/supplier/queries/types";
import MessageModal from "../../../../../customComponents/MessageModal";
interface formDataProp {
  formData: ItemList;
  setFormData: React.Dispatch<React.SetStateAction<ItemList>>;
}
interface addOneTimeProp {
  addOneItem: boolean;
  setAddOneItem: React.Dispatch<React.SetStateAction<boolean>>;
}
interface Props {
  operation: Operation;
  hanldeItemRow: (formData: ItemList, lastFunction: () => void) => void;
  itemsCount: number;
  setModal: (value: React.SetStateAction<boolean>) => void;
  addOneItemState: addOneTimeProp;
  formDataState: formDataProp;
}

const AddItemModal = ({
  operation,
  hanldeItemRow,
  itemsCount,
  setModal,
  addOneItemState,
  formDataState,
}: Props) => {
  const initialValues: ItemList = {
    approxRate: "",
    approxValue: "",
    itemId: 0,
    presentStk: "",
    priority: "",
    remarks: "",
    reqQty: "",
    tax: "",
    taxable: "",
    trnNeedBefore: "",
    udfItemDesc: "",
    uom: "",
    usedFor: "",
    deliveryRate: "",
    installationRate: "",
    otherRate: "",
    taxedValue: "",
    approxTaxableValue: "",
  };
  const [message, setMessage] = useState(emptyMessage);
  const { state, dispatch } = useContext(AppContext);
  const { formData, setFormData } = formDataState;
  const { addOneItem, setAddOneItem } = addOneItemState;
  const [assign, setAssign] = useState(false);
  const { itemLabel } = useLabels();
  const { Material } = useFormJson();
  const handleValueChange = (
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
    meta: FormikProps<ItemList>
  ) => {
    const { name, value } = e.target as HTMLInputElement;

    switch (name) {
      case "reqQty":
        changeValue(
          Number(formData.approxRate),
          Number(value),
          Number(formData.deliveryRate),
          Number(formData.installationRate),
          Number(formData.otherRate),
          Number(formData.tax),
          e
        );
        meta.handleChange(e);
        break;
      case "approxRate":
        changeValue(
          Number(value),
          Number(formData.reqQty),
          Number(formData.deliveryRate),
          Number(formData.installationRate),
          Number(formData.otherRate),
          Number(formData.tax),
          e
        );
        meta.handleChange(e);
        break;
      case "deliveryRate":
        changeValue(
          Number(formData.approxRate),
          Number(formData.reqQty),
          Number(value),
          Number(formData.installationRate),
          Number(formData.otherRate),
          Number(formData.tax),
          e
        );
        meta.handleChange(e);
        break;
      case "installationRate":
        changeValue(
          Number(formData.approxRate),
          Number(formData.reqQty),
          Number(formData.deliveryRate),
          Number(value),
          Number(formData.otherRate),
          Number(formData.tax),
          e
        );
        meta.handleChange(e);
        break;
      case "otherRate":
        changeValue(
          Number(formData.approxRate),
          Number(formData.reqQty),
          Number(formData.deliveryRate),
          Number(formData.installationRate),
          Number(value),
          Number(formData.tax),
          e
        );
        meta.handleChange(e);
        break;
      case "tax":
        changeValue(
          Number(formData.approxRate),
          Number(formData.reqQty),
          Number(formData.deliveryRate),
          Number(formData.installationRate),
          Number(formData.otherRate),
          Number(value),
          e
        );
        meta.handleChange(e);
        break;
      default:
        setFormData(() => ({
          ...formData,
          [name]: value,
        }));
        meta.handleChange(e);
        break;
    }
  };
  const handleClear = () => {
    setFormData(initialValues);
    dispatch({
      type: materialStatesPayloadTypes.SET_ITEM_ID,
      payload: {
        itm: null,
      },
    });
    dispatch({
      type: materialStatesPayloadTypes.SUPPLIERS,
      payload: {
        selectedSuppliers: [],
      },
    });
  };

  const hanldeItemChange = (
    newValue: itmType,
    uom: AtsStckItemEdge | undefined
  ) => {
    if (newValue) {
      dispatch({
        type: materialStatesPayloadTypes.SET_ITEM_ID,
        payload: {
          itm: newValue,
        },
      });
      if (uom) {
        setFormData({
          ...formData,
          uom: uom.node.uomDetails.uom,
          itemId: newValue.value,
        });
      }
      // setSelectedItem(newValue);
    } else {
      dispatch({
        type: materialStatesPayloadTypes.SET_ITEM_ID,
        payload: {
          itm: null,
        },
      });
      setFormData({
        ...formData,
        uom: "",
        itemId: 0,
      });
    }
  };
  const priorityOptions = Object.values(PriorityEnum);
  const changeValue = (
    approxRate: number,
    reqQty: number,
    deliveryRate: number,
    installationRate: number,
    otherRate: number,
    tax: number,
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => {
    const { name, value } = e.target as HTMLInputElement;

    const taxable =
      Number(approxRate) * Number(reqQty) +
      Number(deliveryRate) +
      Number(installationRate) +
      Number(otherRate);

    const taxesValue = (Number(tax) / 100) * taxable;

    const netValue = taxable + taxesValue;

    setFormData({
      ...formData,
      [name]: value,
      approxTaxableValue: taxable.toString(),
      taxedValue: taxesValue.toString(),
      approxValue: netValue.toString(),
    });
  };

  const handleSubmit = () => {
    hanldeItemRow(formData, () => {
      handleClear();
      if (!addOneItem) {
        const AutoInputs = document.getElementsByClassName(
          "material-item-add__form--details--flex"
        )[0];
        (AutoInputs.getElementsByTagName(INPUT)[0] as HTMLInputElement).focus();
      }
    });
  };

  return (
    <>
      <div className="material-item-add">
        <div className="material-item-add__title">
          <Title>Add {itemLabel}</Title>
          <img src={Close} alt="" onClick={() => setModal(false)} />
        </div>

        <Formik
          initialValues={formData}
          validationSchema={materialItemValidation}
          onSubmit={handleSubmit}
          enableReinitialize
          validateOnChange
        >
          {(meta) => {
            return (
              <Form className="material-item-add__form">
                <div className="material-item-add__form--details row g-0">
                  <div className="material-item-add__form--details--left col">
                    {Material.AddItem.leftForm.map(
                      (field: LabelProps, key: React.Key) => {
                        if (field.dataType === "textarea") {
                          return (
                            <React.Fragment key={key}>
                              <div className="label-grid">
                                <Label>{field.labelName}</Label>
                                <TextArea
                                  value={formData[field.inputName]}
                                  onChange={(
                                    e: React.ChangeEvent<HTMLTextAreaElement>
                                  ) => {
                                    handleValueChange(e, meta);
                                  }}
                                  type={field.dataType}
                                  rows={3}
                                  name={field.inputName}
                                  onKeyDown={(e) => {
                                    hanldeTextAreaFormEvent(
                                      e,
                                      setFormData as React.Dispatch<
                                        React.SetStateAction<{
                                          [key: string]: string | number;
                                        }>
                                      >
                                    );
                                  }}
                                />
                              </div>
                              {meta.touched[field.inputName] &&
                              meta.errors[field.inputName] ? (
                                <div className="label-grid">
                                  <span />
                                  <span className="nodata">
                                    {meta.errors[field.inputName]}
                                  </span>
                                </div>
                              ) : null}
                            </React.Fragment>
                          );
                        } else if (field.dataType === "number") {
                          return (
                            <React.Fragment key={key}>
                              <div className="label-grid">
                                <Label>{field.labelName}</Label>
                                <InputNumber
                                  value={formData[field.inputName]}
                                  onChange={(
                                    e: React.ChangeEvent<HTMLInputElement>
                                  ) => {
                                    handleValueChange(e, meta);
                                  }}
                                  disabled={field.disabled}
                                  name={field.inputName}
                                  required={field.required}
                                  maxLength={field.maxLength}
                                  onKeyDown={handleFormEvent}
                                  className={field.className}
                                />
                              </div>
                              {meta.touched[field.inputName] &&
                              meta.errors[field.inputName] ? (
                                <div className="label-grid">
                                  <span />
                                  <span className="nodata">
                                    {meta.errors[field.inputName]}
                                  </span>
                                </div>
                              ) : null}
                            </React.Fragment>
                          );
                        } else if (field.dataType === "items") {
                          return (
                            <React.Fragment key={key}>
                              <div className="label-grid">
                                <Label>{itemLabel} Description</Label>
                                <div className="material-item-add__form--details--flex">
                                  <ItemSelect
                                    onChange={hanldeItemChange}
                                    value={state.itm ? state.itm.value : 0}
                                    onKeyDown={(e) => {
                                      if (e.key === Keys.ENTER) {
                                        e.preventDefault();
                                        handleMUISelectEvent(e);
                                      }
                                    }}
                                    placeholder=""
                                  />
                                </div>
                              </div>
                            </React.Fragment>
                          );
                        } else {
                          return (
                            <React.Fragment key={key}>
                              <InputHoc
                                LabelName={field.labelName}
                                values={formData[field.inputName]}
                                name={field.inputName}
                                onChange={(
                                  e: React.ChangeEvent<HTMLInputElement>
                                ) => {
                                  handleValueChange(e, meta);
                                }}
                                required={field.required}
                                autoFocus={field.autoFocus}
                                onKeyDown={handleFormEvent}
                              />
                              {meta.touched[field.inputName] &&
                              meta.errors[field.inputName] ? (
                                <div className="label-grid">
                                  <span />
                                  <span className="nodata">
                                    {meta.errors[field.inputName]}
                                  </span>
                                </div>
                              ) : null}
                            </React.Fragment>
                          );
                        }
                      }
                    )}
                  </div>
                  <div className="material-item-add__form--details--right col">
                    {Material.AddItem.rightForm.map(
                      (field: LabelProps, key: React.Key) => {
                        if (field.dataType === "textarea") {
                          return (
                            <React.Fragment key={key}>
                              <div className="label-grid">
                                <Label>{field.labelName}</Label>
                                <TextArea
                                  value={formData[field.inputName]}
                                  onChange={(
                                    e: React.ChangeEvent<HTMLTextAreaElement>
                                  ) => {
                                    handleValueChange(e, meta);
                                  }}
                                  type={field.dataType}
                                  rows={3}
                                  name={field.inputName}
                                  onKeyDown={(e) => {
                                    hanldeTextAreaFormEvent(
                                      e,
                                      setFormData as React.Dispatch<
                                        React.SetStateAction<{
                                          [key: string]: string | number;
                                        }>
                                      >
                                    );
                                  }}
                                />
                              </div>
                              {meta.touched[field.inputName] &&
                              meta.errors[field.inputName] ? (
                                <div className="label-grid">
                                  <span />
                                  <span className="nodata">
                                    {meta.errors[field.inputName]}
                                  </span>
                                </div>
                              ) : null}
                            </React.Fragment>
                          );
                        } else if (field.dataType === "number") {
                          return (
                            <React.Fragment key={key}>
                              <div className="label-grid">
                                <Label>{field.labelName}</Label>
                                <InputNumber
                                  value={formData[field.inputName]}
                                  onChange={(
                                    e: React.ChangeEvent<HTMLInputElement>
                                  ) => {
                                    handleValueChange(e, meta);
                                  }}
                                  name={field.inputName}
                                  required={field.required}
                                  maxLength={field.maxLength}
                                  className={field.className}
                                  onKeyDown={handleFormEvent}
                                />
                              </div>
                              {meta.touched[field.inputName] &&
                              meta.errors[field.inputName] ? (
                                <div className="label-grid">
                                  <span />
                                  <span className="nodata">
                                    {meta.errors[field.inputName]}
                                  </span>
                                </div>
                              ) : null}
                            </React.Fragment>
                          );
                        } else if (field.dataType === "preferrefVendor") {
                          return (
                            <React.Fragment key={key}>
                              <div className="label-grid">
                                <Label>{field.labelName}</Label>
                                <div className="material-item-add__form--details--flex">
                                  <MultiSelectSupplier
                                    onChange={(newValue) => {
                                      dispatch({
                                        type: materialStatesPayloadTypes.SUPPLIERS,
                                        payload: {
                                          selectedSuppliers: newValue,
                                        },
                                      });
                                      setFormData({
                                        ...formData,
                                        preferedSupplierIds: newValue
                                          .map(({ value }) => value)
                                          .join(";"),
                                      });
                                    }}
                                    autoCompleteValue={state.selectedSuppliers}
                                    handleClear={handleClear}
                                    onKeyDown={(e) => {}}
                                    input={{
                                      itemID: 0,
                                      query_type: LdgrQueryType.ALL,
                                      tableLevel: undefined,
                                    }}
                                  />
                                  <img
                                    src={DataFetch}
                                    alt=""
                                    className="data-fetch-icon"
                                    onClick={() => setAssign(!assign)}
                                  />
                                </div>
                              </div>
                            </React.Fragment>
                          );
                        } else if (field.dataType === "priority") {
                          return (
                            <React.Fragment key={key}>
                              <div className="label-grid">
                                <Label>{field.labelName}</Label>
                                <FormAutocomplete
                                  className={formClasses.inputRoot}
                                  options={priorityOptions}
                                  onKeyDown={(e) => {
                                    if (e.key === Keys.ENTER) {
                                      e.preventDefault();
                                      handleMUISelectEvent(e);
                                    }
                                  }}
                                  openOnFocus
                                  forcePopupIcon
                                  onChange={(e, newValue) => {
                                    if (newValue) {
                                      setFormData({
                                        ...formData,
                                        priority: newValue as string,
                                      });
                                    } else {
                                      setFormData({
                                        ...formData,
                                        priority: "",
                                      });
                                    }
                                  }}
                                  value={formData.priority}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      fullWidth
                                      className={formClasses.formControlRoot}
                                    />
                                  )}
                                />
                              </div>
                            </React.Fragment>
                          );
                        } else {
                          return (
                            <React.Fragment key={key}>
                              <InputHoc
                                LabelName={field.labelName}
                                values={formData[field.inputName]}
                                name={field.inputName}
                                onChange={(
                                  e: React.ChangeEvent<HTMLInputElement>
                                ) => {
                                  handleValueChange(e, meta);
                                }}
                                type={field.dataType}
                                required={field.required}
                                autoFocus={field.autoFocus}
                                onKeyDown={handleFormEvent}
                              />
                              {meta.touched[field.inputName] &&
                              meta.errors[field.inputName] ? (
                                <div className="label-grid">
                                  <span />
                                  <span className="nodata">
                                    {meta.errors[field.inputName]}
                                  </span>
                                </div>
                              ) : null}
                            </React.Fragment>
                          );
                        }
                      }
                    )}
                  </div>
                </div>
                <div className="row g-0">
                  <div className="col">
                    <Button mode="save" type="submit">
                      &nbsp;({itemsCount})
                    </Button>
                    <Button mode="clear" onClick={handleClear} type="button" />
                    <Button
                      mode="cancel"
                      onClick={() => setModal(false)}
                      type="button"
                    />
                  </div>
                  <div className="col flex-end">
                    <Button
                      mode="save-continue"
                      onClick={() => {
                        if (formData.reqQty) {
                          setAddOneItem(true);
                          handleSubmit();
                        } else {
                          setMessage({
                            message: "Required quantity",
                            flag: true,
                            operation: Operation.NONE,
                          });
                        }
                      }}
                      type="button"
                    />
                  </div>
                </div>
              </Form>
            );
          }}
        </Formik>
      </div>

      <CustomModal
        isOpen={assign}
        onRequestClose={() => setAssign(!assign)}
        contentComponent={<Assign setModalFlag={setAssign} />}
        style={AddModalStyles}
      />
      <MessageModal
        handleClose={() => setMessage(emptyMessage)}
        modalFlag={message.flag}
        operation={message.operation}
        value={message.message}
      />
    </>
  );
};

export default AddItemModal;
